import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Shell from "@/components/Shell";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import Levels from "@/pages/Levels";
import OilPairs from "@/pages/OilPairs";
import Settings from "@/pages/Settings";
import SuperAdmin from "@/pages/SuperAdmin";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="grid min-h-screen place-items-center bg-[#0B0F17] text-sm text-slate-500" data-testid="auth-loading">Loading</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function SuperOnly({ children }) {
  const { user } = useAuth();
  if (user?.role !== "superadmin") return <Navigate to="/levels" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route element={<Protected><Shell /></Protected>}>
            <Route path="/" element={<Navigate to="/levels" replace />} />
            <Route path="/levels" element={<Levels />} />
            <Route path="/oil-pairs" element={<OilPairs />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/super" element={<SuperOnly><SuperAdmin /></SuperOnly>} />
          </Route>
          <Route path="*" element={<Navigate to="/levels" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" richColors />
    </AuthProvider>
  );
}
